<template>
  <div style="padding: 5px;">
    <TypeWorkLeave />
  </div>
</template>
<script>
import TypeWorkLeave from "./components/typeWorkLeave";
export default {
  components: { TypeWorkLeave },
  props: {},
  data() {
    return {};
  },
  methods: {},
};
</script>
<style lang="css" scoped></style>
